/* @flow */

import { listReset } from 'src/shared/app/base/style/token/helper';

export default {
  root: {
    ...listReset,

    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  item: {
    margin: '0 4px',
  },
};
